import { GuestScaffold } from './scaffold'
import "./styles.scss"

export default function RavGuest() {

    return <GuestScaffold />
}